// Mirrors Debtor.DEBTOR_DECLINED_STATUS_GROUPING on the backend. `do_not_contact`
// is deliberately excluded because it is not part of that grouping.
const DECLINED_CREDIT_STATUSES = new Set(["declined", "declined_3_months", "declined_6_months"]);

export const DECLINED_DEBTOR_FACTORING_NOTICE =
  "You cannot factor a funding request for a debtor in declined status. Please go back and update this FR to a Non Factored Invoice Type to continue";

// Shown before submission on the create form, where there is no funding request to
// go back to and the non-factored option has already been locked on.
export const DECLINED_DEBTOR_NON_FACTORED_LOCKED_NOTICE =
  "This customer's credit is declined, so this invoice can only be submitted as non-factored — we have set that for you.";

// The debtor arrives as snake_case `credit_approved` from the REST debtor search
// and as camelCase `creditApproved` from the funding request GraphQL query.
export const getDebtorCreditStatus = (debtor?: any): string | undefined => {
  const status = debtor?.credit_approved ?? debtor?.creditApproved;
  return typeof status === "string" ? status.toLowerCase() : undefined;
};

export const isDeclinedDebtor = (debtor?: any) => {
  const status = getDebtorCreditStatus(debtor);
  return !!status && DECLINED_CREDIT_STATUSES.has(status);
};
